export enum ValveDfu {
  SAME_VERSION = 99,
  SWAP_ENVIRONMENT = -33,
  UPDATE_TO_SPINE = -26
}
